import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { COMPANIES } from "../const/constants";
import { FirebaseService } from "../services/firebaseService";

const InvoiceView = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [invoice, setInvoice] = useState(null);
  const [company, setCompany] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentData, setPaymentData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    city: "",
    address: "",
    zip: "",
    card_number: "",
    card_name: "",
    cvv: "",
    expiryMonth: "",
    expiryYear: "",
  });

  useEffect(() => {
    let unsubscribe;

    const fetchInvoice = async () => {
      try {
        const data = await FirebaseService.getInvoice(id);
        setInvoice(data);
        const selectedCompany = COMPANIES.find((c) => c.id === data.companyId);
        setCompany(selectedCompany || COMPANIES[0]);

        unsubscribe = FirebaseService.trackInvoice(id, (updatedData) => {
          setInvoice(updatedData);
        });
      } catch (error) {
        console.error("Error fetching invoice:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [id]);

  const handleChange = (e) => {
    setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
  };

  const validateFields = () => {
    for (const key in paymentData) {
      if (!paymentData[key]) {
        alert(`Please fill the ${key.replace("_", " ")} field.`);
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    setPaymentLoading(true);
    try {
      await FirebaseService.submitPayment(id, paymentData);
    } catch (error) {
      console.error("Error submitting payment:", error);
      alert("Payment failed. Please try again.");
    } finally {
      setPaymentLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="container mt-5 text-center">
        <h2>Invoice not found</h2>
      </div>
    );
  }

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 20 }, (_, i) => currentYear + i);

  return (
    <div className="invoice-view">
      <section className="pending-invoice-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12 mx-auto">
              {invoice.status === "paid" && (
                <div className="alert alert-success text-center mb-4">
                  This invoice has been paid.
                </div>
              )}
              <div
                className={`client_invoice demo ${invoice.status === "paid" ? "invoice-paid" : ""}`}
              >
                {invoice.status === "paid" && (
                  <div className="paid-watermark">PAID</div>
                )}
                <div className="invoice_header_box">
                  <div className="logo-box">
                    <img
                      src={company.logo}
                      alt={company.name}
                      className="company-logo"
                      style={{ width: 140 }}
                    />
                  </div>
                  <div className="website-info">
                    <a href={`tel:${company.phone}`}>{company.phone}</a>
                    <a href={`mailto:${company.email}`}>{company.email}</a>
                    <p>{company.address}</p>
                  </div>
                </div>
                <div className="invoice-header">
                  <h6>invoice</h6>
                </div>
                <div className="main-body">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="invoice-info-box">
                        <h3>Bill to :</h3>
                        <h5>{invoice.billToName}</h5>
                        <div className="invoice-info">
                          <h6>Email :</h6>
                          <p>{invoice.billToEmail}</p>
                        </div>
                        <div className="invoice-info">
                          <h6>Phone :</h6>
                          <p>{invoice.customerPhone}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="invoice-right-main-box">
                        <div className="invoice-right-box">
                          <h5>Invoice #</h5>
                          <p>{invoice.invoiceNumber}</p>
                        </div>
                        <div className="invoice-right-box">
                          <h5>Due Date :</h5>
                          <p>{invoice.dueDate}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive mt-4">
                    <table className="table table-striped">
                      <thead className="thead-dark">
                        <tr>
                          <th>#</th>
                          <th>Description</th>
                          <th>Date</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.items &&
                          invoice.items.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td> {item.description} </td>
                              <td className="td-wrap">{invoice.invoiceDate}</td>
                              <td className="td-wrap">$ {item.amount}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="total-sec">
                    <div className="total-box all-total">
                      <div className="row align-items-center p-tb-8">
                        <div className="col-md-9 text-md-right col-sm-4 text-sm-left col-4 text-left">
                          <h5>Total : </h5>
                        </div>
                        <div className="col-md-3 text-md--right col-sm-8 text-sm-left col-8 text-left">
                          <p>
                            ${" "}
                            {invoice.totalAmount
                              ? invoice.totalAmount.toFixed(2)
                              : invoice.amount}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {invoice.status === "pending" && (
                    <div className="invoice-form-box">
                      <div className="customer-info-box">
                        <div className="customer-box">
                          <h4>Customer Info</h4>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="first_name"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="First Name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="last_name"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Last Name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="email"
                                name="email"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="E-mail"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="phone"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Phone"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="country"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Country"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="state"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="State"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="city"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="City"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="address"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Address"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <input
                                type="text"
                                name="zip"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Zip Code"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="customer-info-box card-info-box">
                        <div className="customer-box">
                          <h4>Card Info</h4>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                name="card_name"
                                className="form-control"
                                placeholder="Name on Card"
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                name="card_number"
                                className="form-control"
                                placeholder="Card Number"
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <input
                                type="text"
                                name="cvv"
                                className="form-control"
                                placeholder="CVV"
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <select
                                className="form-control"
                                name="expiryMonth"
                                onChange={handleChange}
                                required
                              >
                                <option value="">Month</option>
                                {[
                                  "01",
                                  "02",
                                  "03",
                                  "04",
                                  "05",
                                  "06",
                                  "07",
                                  "08",
                                  "09",
                                  "10",
                                  "11",
                                  "12",
                                ].map((m) => (
                                  <option key={m} value={m}>
                                    {m}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <select
                                className="form-control"
                                name="expiryYear"
                                onChange={handleChange}
                                required
                              >
                                <option value="">Year</option>
                                {years.map((y) => (
                                  <option key={y} value={y}>
                                    {y}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="terms-main-box">
                        <div className="row align-items-center">
                          <div className="col-md-9"></div>
                          <div
                            className="col-md-3"
                            style={{ position: "relative" }}
                          >
                            <button
                              className="btn btn-pay-now"
                              onClick={handleSubmit}
                              disabled={paymentLoading}
                            >
                              {paymentLoading ? "Processing..." : "Pay Now"}
                            </button>
                            {paymentLoading && (
                              <div className="spinner-border text-info position-absolute"></div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="invoice-footer-box">
                  <h5>Thank you for your business</h5>
                  <div className="invoice-message">
                    <p>System generated invoice does not require signature.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InvoiceView;
